import Technology from '../model/Technology'
import Image from '../model/Image'
import HTMLImage from '@/images/html.png'
import CSSImage from '@/images/css.png'
import JavascriptImage from '@/images/javascript.png'
import JavaImage from '@/images/java.png'
import MySQLImage from '@/images/mysql.png'
import VueImage from '@/images/vue.png'
import ReactImage from '@/images/react.png'
import LaravelImage from '@/images/laravel.png'
import GoImage from '@/images/go.png'
import GitImage from '@/images/git.png'

const HTML = "html"
const CSS = "css"
const JAVASCRIPT = "js"
const JAVA = "java"
const MYSQL = "mysql"
const VUE = "vue"
const REACT = "react"
const LARAVEL = "laravel"
const GO = "go"
const GIT = "git"

interface TechnologyStruct {
    [key: string]: Technology
}

const Technologies: TechnologyStruct = {
    [HTML]: new Technology(new Image(HTMLImage), "HTML"),
    [CSS]: new Technology(new Image(CSSImage), "CSS"),
    [JAVASCRIPT]: new Technology(new Image(JavascriptImage), "Javascript"),
    [JAVA]: new Technology(new Image(JavaImage), "Java"),
    [MYSQL]: new Technology(new Image(MySQLImage), "MySQL"),
    [VUE]: new Technology(new Image(VueImage), "Vue"),
    [REACT]: new Technology(new Image(ReactImage), "React"),
    [LARAVEL]: new Technology(new Image(LaravelImage), "Laravel"),
    [GO]: new Technology(new Image(GoImage), "Go"),
    [GIT]: new Technology(new Image(GitImage), "Git"),
}

export { HTML, CSS, JAVASCRIPT, JAVA, MYSQL, VUE, REACT, LARAVEL, GO, GIT, Technologies }